import { createHashRouter, RouterProvider } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Paths } from "../common/constants";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import Loader from "../components/loader";

// const Profile = lazy(() => import("../pages/profile"));
const Login = lazy(() => import("../pages/login"));
const Organization = lazy(() => import("../pages/organization"));
const AuthRefresh = lazy(() => import("../pages/auth/refresh"));

const router = createHashRouter([
  {
    path: Paths.LOGIN,
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: Paths.ORGANIZATION,
    element: (
      <PrivateRoute>
        <Organization />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/refresh",
    element: (
      <PrivateRoute>
        <AuthRefresh />
      </PrivateRoute>
    ),
  },
]);

const RoutesManager = () => {
  return (
    <Suspense fallback={<Loader />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default RoutesManager;
